import { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { TableHead, TableRow, Typography, Grid, Button } from '@mui/material';
import { DateTimePicker, SelectField, Dialog, Tooltip } from 'style-guide';
import { REQUEST_ACTIONS, sendRequest, sendRequest1, setOrderData, setOrderData1 } from 'utils/Communicator';
import { sendNewChatMsgNotification, sendNewOrderNotification } from 'utils/Notifications';
import { useDispatch, useSelector } from 'react-redux';
import { STAGES_OPTIONS, USA_STATES } from 'constants/global-constants';
import OrderSearch from '../OrderTable/OrderSearch';
import { getOrders, onCustChatListChange, onChatListChange, onOrdersCountChange, onChatCountChange, onChatCountTChange, onChatCountCChange, onChatCountCTChange, onUserSpecificOrdersCountChange, onPageChange, onUnConfirmedOrdersCountChange } from 'reducers/order-reducers/ordersSlicer';
import {
    onConsigneeIdChange,
    onCountryOfOriginIdChange,
    onShipperIdChange,
    onShippingModeIdChange,
    onSubModeIdChange,
    onUserLocalIdChange,
    onUserTracerChange,
    onUserCustomsChange,
    onUserAbroadIdChange,
    onIlReminderDateChange,
    onETAChange,
    onETDChange,
    OnStageSearchChange,
    onReminderDateChange,
    onOriginStateChange,
    onSortFilterChange,
    resetOrderTableFilterSlice,
    onUrgentShipmentChange,
    setSearchText,
    setDataInterval,
    setChatInterval,
    OnFileUploadStatusChange,
    setOrderUpdateNum,
} from 'reducers/order-reducers/orderTableFilterSlicer';
import { onShipperNameOptionsChange, onShippersChange } from 'reducers/shippersSlicer';
import { onCustomerNameOptionsChange, onCustomersChange } from 'reducers/customersSlicer';
import { onConsigneeNameOptionsChange, onConsigneesChange } from 'reducers/consigneesSlicer';

import { snackbarToggle } from 'reducers/snackbarSlicer';
import { addOrderFilter, addSearchFilter, StyledTableCell, advancedSearchSelectedStyle, advancedSearchDefaultStyle, usePrevious } from 'Utils';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import AdvancedSearchDialog from './AdvancedSearchDialog';

import {
    onUserNLDataChange,
    onUserUSDataChange,
    onUserILDataChange,
    onUserILNamesChange,
    onUserNLNamesChange,
    onUserUSNamesChange,
    onCustomerNamesChange,
    onSubModeDataChange,
    onShippingModeDataChange,
    onCountryOfOriginDataChange,
    onAirPoaDataChange,
    onAirPolDataChange,
    onLclPoaDataChange,
    onLclPolDataChange,
    onIncotermsDataChange,
    onFileCodesChange,
    onFCLType20DataChange,
    onFCLType40DataChange,
} from 'reducers/order-reducers/predefinedDataSlicer';

var orderTimeout = null;

var lastUpdatedOrderList = -1, loginUser123 = null, pageName123 = null, selectedLocationIndex123 = null, customerId123 = null, urgentShipment123 = null, userLocalNumber123 = null, userAbroadNumber123 = null, consigneeId123 = null, shipperId123 = null, countryOfOriginId123 = null, originState123 = null, shippingModeId123 = null, subModeId123 = null, userLocalId123 = null, userTracer123 = null, userCustoms123 = null, userAbroadId123 = null, dueDate123 = null, search123 = null, searchText123 = null, lastUpdateDate123 = null, reminderDate123 = null, ilReminderDate123 = null, startReminderDate123 = null, endReminderDate123 = null, startIlReminderDate123 = null, endIlReminderDate123 = null, stageSearch123 = null, stageStateSearch123 = null, reminderDateAdv123 = null, ilReminderDateAdv123 = null, pageName123 = null, fileNumber123 = null, etaDate123 = null, etdDate123 = null, sortFilter123 = {}, orders123 = null, fileUploadStatus123=null;

const OrderTableHeader = ({ loginUser, setFilterSpinner, pageName, searchText1, orders }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const onHandleChange = (event, action) => dispatch(action(event.target.value));
    const [openAdvSearchDialog, setOpenAdvSearchDialog] = useState(false);
    const onAdvSearchDialogHandleOpen = () => setOpenAdvSearchDialog(true);

    //const [lastUpdatedOrderList, setLastUpdatedOrderList] = useState(-1);

    const {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        customerId,
        shipperId,
        countryOfOriginId, originState, fileNumber,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms,
        urgentShipment,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        etaDate,
        etdDate,
        reminderDate,
        selectedLocationIndex,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        fileUploadStatus,
        stageStateSearch, searchText, chatInterval, dataInterval, orderUpdateNum,
        reminderDateAdv, ilReminderDateAdv, sortFilter } = useSelector(state => state.orderTableFilter);
    const { shipperNameOptions } = useSelector(state => state.shippers);
    const { consigneeNameOptions } = useSelector(state => state.consignees);
    const { userILNames, userNLNames, userUSNames, shippingModeData, subModeData, countryOfOriginData } = useSelector(
        state => state.predefinedData,
    );
    const [shippingModeData1, setShippingModeData1] = useState([]);
    const [countryOfOriginData1, setCountryOfOriginData1] = useState([]);
    const [shipperNameOptions1, setShipperNameOptions1] = useState([]);
    const [consigneeNameOptions1, setConsigneeNameOptions1] = useState([]);

    const fuFileUploadStatuses = [
        { id: null, name: "Reset" },
        { id: 100, name: "None" },
        { id: 1, name: "Set" },
        { id: 10, name: "Ready" },
    ];
    const custFileUploadStatuses = [
        { id: null, name: "Reset" },
        { id: 100, name: "None" },
        { id: 10, name: "Ready" },
        { id: 20, name: "In progress" },
        { id: 30, name: "Completed" },
        { id: 40, name: "Approve" },
        { id: 50, name: "Reject" },
    ];
    const adminFileUploadStatuses = [
        { id: null, name: "Reset" },
        { id: 100, name: "None" },
        { id: 1, name: "Set" },
        { id: 10, name: "Ready" },
        { id: 20, name: "In progress" },
        { id: 30, name: "Completed" },
        { id: 40, name: "Approve" },
        { id: 50, name: "Reject" },
    ];

    const [userILImporterNames, setUserILImporterNames] = useState([]);
    const [userNLImporterNames, setUserNLImporterNames] = useState([]);
    const [userUSImporterNames, setUserUSImporterNames] = useState([]);
    const [userILTracerNames, setUserILTracerNames] = useState([]);
    const [userILCustomsNames, setUserILCustomsNames] = useState([]);
    const { page, size, chatCount, userSpecificOrdersCount, unConfirmedOrdersCount } = useSelector(state => state.orders);
    const prevPage = usePrevious({ page });
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const failedCallback1 = useCallback(message => {
        dispatch(snackbarToggle({ type: 'error', message }))
        dispatch(setOrderUpdateNum(false));
    }, [dispatch]);
    const dataRefreshInterval = useRef(null);
    const chatRefreshInterval = useRef(null);
    const setSearchText1 = (data) => {
        dispatch(setSearchText(data));
    }
    useEffect(() => {
        if (!location?.state?.search && !orderUpdateNum) {
            setFilterSpinner(true);
            dispatch(setOrderUpdateNum(true));
            sendRequest(`/api/order/count?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}`, REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    dispatch(onOrdersCountChange(response?.ordersCount)); sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                    dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                    dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                    dispatch(onChatCountCChange(response?.unreadChatCustomsCount)); dispatch(onChatCountChange(response?.unreadChatCount)); sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount); dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount)); dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                    sendRequest1(
                        `/api/order/advOrders?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}&page=${prevPage?.page == page && addSearchFilter(customerId, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)?.length ? 0 : page}&size=${size}`,
                        REQUEST_ACTIONS.GET,
                        '',
                        {
                            successCallback: response => {
                                lastUpdatedOrderList = new Date().getTime();
                                dispatch(setOrderUpdateNum(false));
                                setOrderData1(dispatch, getOrders, response, loginUser, failedCallback);
                                setFilterSpinner(false);
                                if (prevPage?.page == page && addSearchFilter(customerId, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, fileNumber, etaDate, etdDate, fileUploadStatus)) {
                                    dispatch(onPageChange(0));
                                }
                            },
                            failedCallback1,
                        },
                    );
                },
                failedCallback1,
            });
            // filtered orders get

        } else {
            if (orderUpdateNum)
                return;
            dispatch(setOrderUpdateNum(true));
            window.history.replaceState({}, '');
            if (!location?.state?.search && !location?.state?.searchText && !location?.state?.locInd)
                return;
            var str = "";
            var loc = selectedLocationIndex;
            if (location?.state?.search) {
                dispatch(setSearchText(location?.state?.search));
                str = location?.state?.search;
            } else if (location?.state?.searchText) {
                dispatch(setSearchText(location?.state?.searchText));
                str = location?.state?.searchText;
            }
            if (location?.state?.locInd) {
                dispatch(setSearchText(location?.state?.locInd));
                loc = location?.state?.locInd;
            }
            const updatedState = { ...location.state, search: null, searchText: null, locInd: null };
            navigate(location, { state: updatedState, replace: true });

            /*if(str)
                sendRequest1(`/api/order/count?${addOrderFilter(loginUser, pageName, loc)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, str, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, fileNumber, etaDate, etdDate)}`, REQUEST_ACTIONS.GET, '', {
                    successCallback: response => {
                        dispatch(onOrdersCountChange(response?.ordersCount)); sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                        dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                        dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                        dispatch(onChatCountCChange(response?.unreadChatCustomsCount)); dispatch(onChatCountChange(response?.unreadChatCount)); sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount); dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount)); dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                    
                    },
                    failedCallback1,
                });*/
            setFilterSpinner(true);
            sendRequest1(`/api/order/count?${addOrderFilter(loginUser, pageName, loc)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, str, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}`, REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    dispatch(onOrdersCountChange(response?.ordersCount));
                    sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                    dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                    dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                    dispatch(onChatCountCChange(response?.unreadChatCustomsCount));
                    dispatch(onChatCountChange(response?.unreadChatCount));
                    sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount);
                    dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount));
                    dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                    sendRequest1(
                        `/api/order/advOrders?${addOrderFilter(loginUser, pageName, loc)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, str, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}&page=${prevPage?.page == page && addSearchFilter(customerId, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, str, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)?.length ? 0 : page}&size=${size}`,
                        REQUEST_ACTIONS.GET,
                        '',
                        {
                            successCallback: response => {
                                lastUpdatedOrderList = new Date().getTime();
                                dispatch(setOrderUpdateNum(false));
                                setOrderData1(dispatch, getOrders, response, loginUser, failedCallback);
                                setFilterSpinner(false);
                                if (prevPage?.page == page && addSearchFilter(customerId, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, str, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, fileNumber, etaDate, etdDate, fileUploadStatus)) {
                                    dispatch(onPageChange(0));
                                }
                            },
                            failedCallback1,
                        },
                    );

                },
                failedCallback1,
            });
        }
    }, [
        consigneeId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        searchText, search,
        //setFilterSpinner,
        //dispatch,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        fileUploadStatus,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv,
        etaDate,
        etdDate, page, size, sortFilter,
    ]);

    useEffect(() => {
        searchText123 = searchText1;
    }, [searchText]);
    useEffect(() => {
        var sd = JSON.parse(JSON.stringify(shippingModeData));
        sd.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
        setShippingModeData1(sd);
    }, [shippingModeData]);
    useEffect(() => {
        var sd = JSON.parse(JSON.stringify(countryOfOriginData));
        sd.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
        setCountryOfOriginData1(sd);
    }, [countryOfOriginData]);
    useEffect(() => {
        var sd = JSON.parse(JSON.stringify(shipperNameOptions));
        sd.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
        setShipperNameOptions1(sd);
    }, [shipperNameOptions]);
    useEffect(() => {
        var sd = JSON.parse(JSON.stringify(consigneeNameOptions));
        sd.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
        setConsigneeNameOptions1(sd);
    }, [consigneeNameOptions]);

    useEffect(() => {
        var names = userILNames.filter(name => (name.department == 1) && name.active != false && name.roleId !== 1);
        var tracers = userILNames.filter(name => name.department == 2 && name.active != false);
        var customs = userILNames.filter(name => name.department == 3 && name.active != false);
        var nlnames = userNLNames.filter(name => (name.department == 1) && name.active != false && name.roleId !== 1);
        var usnames = userUSNames.filter(name => (name.department == 1) && name.active != false && name.roleId !== 1);
        setUserILImporterNames(names);
        setUserNLImporterNames(nlnames);
        setUserUSImporterNames(usnames);
        setUserILTracerNames(tracers);
        setUserILCustomsNames(customs);
    }, [userILNames]);

    useEffect(() => {
        return () => {
            /*clearInterval(dataRefreshInterval.current);
            dataRefreshInterval.current = null;
            clearInterval(chatRefreshInterval.current);
            chatRefreshInterval.current = null;*/
            clearInterval(chatInterval);
            dispatch(setChatInterval(null));
            clearInterval(dataInterval);
            dispatch(setDataInterval(null));
            clearInterval(orderTimeout);
            dispatch(setDataInterval(null));
        }
    }, []);

    useEffect(() => {
        if (loginUser.authority != "Admin" && loginUser.department != 4) {
            sendRequest(
                `/api/chat/list?${addOrderFilter(loginUser, '', selectedLocationIndex)}`,
                REQUEST_ACTIONS.GET,
                '',
                {
                    successCallback: response => {
                        dispatch(onChatListChange(response))
                    },
                    failedCallback,
                },
            );
            if (loginUser.location.code === "IL") {
                sendRequest(
                    `/api/chat/customerChat?${addOrderFilter(loginUser, '', selectedLocationIndex)}`,
                    REQUEST_ACTIONS.GET,
                    '',
                    {
                        successCallback: response => {
                            dispatch(onCustChatListChange(response))
                        },
                        failedCallback,
                    },
                );
            }
        }
        if (loginUser.authority !== "Admin" && loginUser.department != 4) {
            var chatInterval1 = setInterval(() => {
                sendRequest(
                    `/api/chat/list?${addOrderFilter(loginUser, '', selectedLocationIndex)}`,
                    REQUEST_ACTIONS.GET,
                    '',
                    {
                        successCallback: response => {
                            dispatch(onChatListChange(response));
                        },
                        failedCallback,
                    },
                );
                if (loginUser.location.code === "IL") {
                    sendRequest(
                        `/api/chat/customerChat?${addOrderFilter(loginUser, '', selectedLocationIndex)}`,
                        REQUEST_ACTIONS.GET,
                        '',
                        {
                            successCallback: response => {
                                dispatch(onCustChatListChange(response))
                            },
                            failedCallback,
                        },
                    );
                }
            }, 100000);
            //chatRefreshInterval.current = chatInterval;
            dispatch(setChatInterval(chatInterval1))
        }
        return () => {
        }
    }, []);
    const sortNotEqual = (sort1, sort2) => {
        if (sort1.nlno != sort2.nlno ||
            sort1.fu != sort2.fu ||
            sort1.ops != sort2.ops ||
            sort1.customs != sort2.customs ||
            sort1.type != sort2.type ||
            sort1.orgCtr != sort2.orgCtr ||
            sort1.orgUS != sort2.orgUS ||
            sort1.shipper != sort2.shipper ||
            sort1.consignee != sort2.consignee ||
            sort1.brooker != sort2.brooker ||
            sort1.etd != sort2.etd ||
            sort1.eta != sort2.eta ||
            sort1.pol != sort2.pol ||
            sort1.pod != sort2.pod ||
            sort1.po != sort2.po ||
            sort1.reminder != sort2.reminder ||
            sort1.date != sort2.date ||
            sort1.clientref != sort2.clientref ||
            sort1.date != sort2.date ||
            sort1.location != sort2.location) {
            return true;
        }
        return false;
    }
    useEffect(() => {
        /*if (dataRefreshInterval.current) {
            clearInterval(dataRefreshInterval.current);
            dataRefreshInterval.current = null;
        }
        if (chatRefreshInterval.current) {
            clearInterval(chatRefreshInterval.current);
            chatRefreshInterval.current = null;
        }*/
        /*if (dataInterval) {
            clearInterval(dataInterval);
            dispatch(setDataInterval(null));
        }*/
        if (orderTimeout) {
            clearInterval(orderTimeout);
            dispatch(setDataInterval(null));
        }
        var changed = false;
        if (pageName123 != pageName || selectedLocationIndex123 != selectedLocationIndex ||
            customerId123 != customerId || urgentShipment123 != urgentShipment || userLocalNumber123 != userLocalNumber ||
            userAbroadNumber123 != userAbroadNumber || consigneeId123 != consigneeId || shipperId123 != shipperId ||
            countryOfOriginId123 != countryOfOriginId || originState123 != originState || shippingModeId123 != shippingModeId ||
            subModeId123 != subModeId || userLocalId123 != userLocalId || userTracer123 != userTracer ||
            userCustoms123 != userCustoms || userAbroadId123 != userAbroadId || dueDate123 != dueDate ||
            search123 != search || searchText123 != searchText || lastUpdateDate123 != lastUpdateDate ||
            reminderDate123 != reminderDate || ilReminderDate123 != ilReminderDate || startReminderDate123 != startReminderDate ||
            endReminderDate123 != endReminderDate || startIlReminderDate123 != startIlReminderDate || endIlReminderDate123 != endIlReminderDate ||
            stageSearch123 != stageSearch || stageStateSearch123 != stageStateSearch || reminderDateAdv123 != reminderDateAdv ||
            ilReminderDateAdv123 != ilReminderDateAdv || fileNumber123 != fileNumber || etaDate123 != etaDate ||
            etdDate123 != etdDate || sortNotEqual(sortFilter123, sortFilter) || fileUploadStatus123 != fileUploadStatus)
            changed = true;
        loginUser123 = loginUser;
        pageName123 = pageName;
        selectedLocationIndex123 = selectedLocationIndex;
        customerId123 = customerId;
        urgentShipment123 = urgentShipment;
        userLocalNumber123 = userLocalNumber;
        userAbroadNumber123 = userAbroadNumber;
        consigneeId123 = consigneeId;
        shipperId123 = shipperId;
        countryOfOriginId123 = countryOfOriginId;
        originState123 = originState;
        shippingModeId123 = shippingModeId;
        subModeId123 = subModeId;
        userLocalId123 = userLocalId;
        userTracer123 = userTracer;
        userCustoms123 = userCustoms;
        userAbroadId123 = userAbroadId;
        dueDate123 = dueDate;
        search123 = search;
        searchText123 = searchText;
        lastUpdateDate123 = lastUpdateDate;
        reminderDate123 = reminderDate;
        ilReminderDate123 = ilReminderDate;
        startReminderDate123 = startReminderDate;
        endReminderDate123 = endReminderDate;
        startIlReminderDate123 = startIlReminderDate;
        endIlReminderDate123 = endIlReminderDate;
        stageSearch123 = stageSearch;
        stageStateSearch123 = stageStateSearch;
        reminderDateAdv123 = reminderDateAdv;
        ilReminderDateAdv123 = ilReminderDateAdv;
        fileNumber123 = fileNumber;
        etaDate123 = etaDate;
        etdDate123 = etdDate;
        sortFilter123 = sortFilter;
        orders123 = orders;
        fileUploadStatus123 = fileUploadStatus;
        if (changed) {
            dispatch(setOrderUpdateNum(true));
            lastUpdatedOrderList = new Date().getTime();
            sendRequest(`/api/order/count?${addOrderFilter(loginUser123, pageName123, selectedLocationIndex123)}${addSearchFilter(customerId123, urgentShipment123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter123, fileNumber123, etaDate123, etdDate123, fileUploadStatus123)}`, REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    dispatch(onOrdersCountChange(response?.ordersCount));
                    sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                    dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                    dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                    dispatch(onChatCountCChange(response?.unreadChatCustomsCount));
                    dispatch(onChatCountChange(response?.unreadChatCount));
                    sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount);
                    dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount));
                    dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                    // filtered orders get
                    sendRequest1(
                        `/api/order/advOrders?${addOrderFilter(loginUser, pageName123, selectedLocationIndex123)}${addSearchFilter(customerId123, urgentShipment123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter123, fileNumber123, etaDate123, etdDate123, fileUploadStatus123)}&page=${prevPage?.page == page && addSearchFilter(customerId123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter, fileNumber123, etaDate123, etdDate123, fileUploadStatus123)?.length ? 0 : page}&size=${size}`,
                        REQUEST_ACTIONS.GET,
                        '',
                        {
                            successCallback: response => {
                                dispatch(setOrderUpdateNum(false));
                                setOrderData1(dispatch, getOrders, response, loginUser, failedCallback);
                                if (prevPage?.page == page && addSearchFilter(customerId123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, fileNumber123, etaDate123, etdDate123, fileUploadStatus123)) {
                                    dispatch(onPageChange(0));
                                }
                            },
                            failedCallback1,
                        },
                    );
                },
                failedCallback1,
            });
        } else {
            orderTimeout = setInterval(() => {
                if (!search123 && !searchText) {
                    //console.log("interval data")
                    sendRequest(`/api/order/lastUpdate`, REQUEST_ACTIONS.GET, '', {
                        successCallback: response => {

                            if (response?.ordersCount != lastUpdatedOrderList || changed) {
                                sendRequest1(
                                    `/api/order/lastUpdateIds?time=` + lastUpdatedOrderList,
                                    REQUEST_ACTIONS.GET,
                                    '',
                                    {
                                        successCallback: res => {
                                            dispatch(setOrderUpdateNum(true));
                                            //var ids = res;
                                            if (res?.length > 0) {
                                                var is = [];
                                                for (var j = 0; j < orders123.length; j++) {
                                                    for (var i = 0; i < res?.length; i++) {
                                                        if (res[i] == orders123[j].id) {
                                                            is.push(res[i])
                                                        }
                                                    }
                                                }
                                                sendRequest1(
                                                    `/api/order/getOrdersByIds?ids=` + is.join(","),
                                                    REQUEST_ACTIONS.GET,
                                                    '',
                                                    {
                                                        successCallback: resp => {
                                                            dispatch(setOrderUpdateNum(false));
                                                            var ords = JSON.parse(JSON.stringify(orders123));
                                                            var ors = [];
                                                            for (var j = 0; j < ords.length; j++) {
                                                                var pushed = false;
                                                                for (var i = 0; i < resp?.length; i++) {
                                                                    if (resp[i].id == ords[j].id) {
                                                                        pushed = true;
                                                                        ors.push(resp[i])
                                                                    }
                                                                }
                                                                if (!pushed) {
                                                                    ors.push(ords[j]);
                                                                }
                                                            }
                                                            setOrderData1(dispatch, getOrders, ors, loginUser, failedCallback);
                                                        },
                                                        failedCallback1,
                                                    },
                                                );
                                            }
                                        },
                                        failedCallback1,
                                    },
                                );
                                lastUpdatedOrderList = response?.ordersCount


                                /*dispatch(setOrderUpdateNum(true));
                                lastUpdatedOrderList = response?.ordersCount;
                                sendRequest(`/api/order/count?${addOrderFilter(loginUser123, pageName123, selectedLocationIndex123)}${addSearchFilter(customerId123, urgentShipment123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter123, fileNumber123, etaDate123, etdDate123)}`, REQUEST_ACTIONS.GET, '', {
                                    successCallback: response => {
                                        dispatch(onOrdersCountChange(response?.ordersCount));
                                        sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                                        dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                                        dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                                        dispatch(onChatCountCChange(response?.unreadChatCustomsCount));
                                        dispatch(onChatCountChange(response?.unreadChatCount));
                                        sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount);
                                        dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount));
                                        dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                                        // filtered orders get
                                        sendRequest1(
                                            `/api/order/advOrders?${addOrderFilter(loginUser, pageName123, selectedLocationIndex123)}${addSearchFilter(customerId123, urgentShipment123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter123, fileNumber123, etaDate123, etdDate123)}&page=${prevPage?.page == page && addSearchFilter(customerId123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, sortFilter, fileNumber123, etaDate123, etdDate123)?.length ? 0 : page}&size=${size}`,
                                            REQUEST_ACTIONS.GET,
                                            '',
                                            {
                                                successCallback: response => {
                                                    dispatch(setOrderUpdateNum(false));
                                                    setOrderData1(dispatch, getOrders, response, loginUser, failedCallback);
                                                    if (prevPage?.page == page && addSearchFilter(customerId123, userLocalNumber123, userAbroadNumber123, consigneeId123, shipperId123, countryOfOriginId123, originState123, shippingModeId123, subModeId123, userLocalId123, userTracer123, userCustoms123, userAbroadId123, dueDate123, search123 ? search123 : searchText123, lastUpdateDate123, reminderDate123, ilReminderDate123, startReminderDate123, endReminderDate123, startIlReminderDate123, endIlReminderDate123, stageSearch123, stageStateSearch123, reminderDateAdv123, ilReminderDateAdv123, pageName123, fileNumber123, etaDate123, etdDate123)) {
                                                        dispatch(onPageChange(0));
                                                    }
                                                },
                                                failedCallback1,
                                            },
                                        );
                                    },
                                    failedCallback1,
                                });*/
                            }
                        },
                        failedCallback1,
                    });
                }
            }, 60000);
        }
        

    }, [
        consigneeId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        searchText,
        page,
        size,
        //setFilterSpinner,
        //dispatch,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv,
        etaDate,
        etdDate, sortFilter,
        fileUploadStatus,
        orders
    ]);
    const refreshData = () => {
        sendRequest('/api/getAllData', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onSubModeDataChange(response.subMode));
                dispatch(onShippingModeDataChange(response.shippingMode));
                dispatch(onAirPoaDataChange(response.poaair));
                dispatch(onAirPolDataChange(response.polair));
                dispatch(onLclPoaDataChange(response.poalcl));
                dispatch(onLclPolDataChange(response.pollcl));
                dispatch(onCountryOfOriginDataChange(response.countryOfOrigin));
                dispatch(onIncotermsDataChange(response.incoterms));
                dispatch(onFileCodesChange(response.codes));
                dispatch(onFCLType20DataChange(response.fclType20));
                dispatch(onFCLType40DataChange(response.fclType40));
            },
            failedCallback,
        });
        sendRequest('/api/usersAll', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onUserILDataChange(response.IL));
                dispatch(onUserNLDataChange(response.NL));
                dispatch(onUserUSDataChange(response.US));
            },
            failedCallback,
        });
        sendRequest('/api/serviceProvider/all?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                dispatch(onShippersChange(response.s1));
                dispatch(onConsigneesChange(response.s2));
                dispatch(onCustomersChange(response.s13));
            },
            failedCallback,
        });
        sendRequest1(
            `/api/order/lastUpdateIds?time=` + lastUpdatedOrderList,
            REQUEST_ACTIONS.GET,
            '',
            {
                successCallback: res => {
                    dispatch(setOrderUpdateNum(true));
                    //var ids = res;
                    if (res?.length > 0) {
                        var is = [];
                        for (var j = 0; j < orders123.length; j++) {
                            for (var i = 0; i < res?.length; i++) {
                                if (res[i] == orders123[j].id) {
                                    is.push(res[i])
                                }
                            }
                        }
                        sendRequest1(
                            `/api/order/getOrdersByIds?ids=` + is.join(","),
                            REQUEST_ACTIONS.GET,
                            '',
                            {
                                successCallback: resp => {
                                    dispatch(setOrderUpdateNum(false));
                                    var ords = JSON.parse(JSON.stringify(orders123));
                                    var ors = [];
                                    for (var j = 0; j < ords.length; j++) {
                                        var pushed = false;
                                        for (var i = 0; i < resp?.length; i++) {
                                            if (resp[i].id == ords[j].id) {
                                                pushed = true;
                                                ors.push(resp[i])
                                            }
                                        }
                                        if (!pushed) {
                                            ors.push(ords[j]);
                                        }
                                    }
                                    setOrderData1(dispatch, getOrders, ors, loginUser, failedCallback);
                                },
                                failedCallback1,
                            },
                        );
                    }
                },
                failedCallback1,
            },
        );
    }

    const clearSort = () => {
        return {
            nlno: null,
            fu: null,
            ops: null,
            customs: null,
            type: null,
            orgCtr: null,
            orgUS: null,
            shipper: null,
            consignee: null,
            brooker: null,
            etd: null,
            eta: null,
            pol: null,
            pod: null,
            po: null,
            reminder: null,
        };
    }

    const isFU = () => {
        if (loginUser.authority === "User") {
            if (loginUser.department == null || loginUser.department == 1)
                return true;
        }
        return false;
    }
    return (
        <TableHead>
            <TableRow className="header">
                <StyledTableCell colSpan={24} style={{ background: "#fff" }}>
                    <Grid item container flexWrap="nowrap" style={{}}>
                        <Grid item container sm={2.5} style={{ padding: "5px" }}>
                            <OrderSearch loginUser={loginUser} setSearchSpinner={setFilterSpinner} pageName={pageName} searchText={searchText} setSearchText={setSearchText1} />
                        </Grid>
                        {((selectedLocationIndex == 0 || selectedLocationIndex == 1) && loginUser.authority != "Admin" && loginUser.department == null || loginUser.department == 1) && <Grid sm={2} style={{ padding: "5px" }}>
                            {(loginUser.location.code === "IL") && <>
                                <SelectField
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    label={<Typography fontSize="0.8vw" fontWeight='bold'>F/U</Typography>}
                                    value={userLocalId}
                                    onChange={event => onHandleChange(event, onUserLocalIdChange)}
                                    options={[{ id: null, name: 'Reset' }, ...userILImporterNames]}
                                />
                            </>}
                            {(loginUser.location.code === 'US') && <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>US</Typography>}
                                value={userAbroadId}
                                onChange={event => onHandleChange(event, onUserAbroadIdChange)}
                                options={[{ id: null, name: 'Reset' }, ...userUSImporterNames]}
                            />}
                            {(loginUser.location.code === 'NL') && <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>NL</Typography>}
                                value={userAbroadId}
                                onChange={event => onHandleChange(event, onUserAbroadIdChange)}
                                options={[{ id: null, name: 'Reset' }, ...userNLImporterNames]}
                            />}
                        </Grid>}
                        {(loginUser.department == 2 || loginUser.department == 3) && loginUser.authority != "Admin" && <Grid sm={2} style={{ padding: "5px" }}>
                            {((loginUser.department == 2)) && <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>OPS</Typography>}
                                value={userTracer}
                                onChange={event => onHandleChange(event, onUserTracerChange)}
                                options={[{ id: null, name: 'Reset' }, ...userILTracerNames]}
                            />}
                            {((loginUser.department == 3)) && <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>Customs</Typography>}
                                value={userCustoms}
                                onChange={event => onHandleChange(event, onUserCustomsChange)}
                                options={[{ id: null, name: 'Reset' }, ...userILCustomsNames]}
                            />}
                        </Grid>}
                        <Grid sm={1.5} style={{ padding: "5px" }}>
                            <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>Type</Typography>}
                                value={shippingModeId}
                                onChange={event => onHandleChange(event, onShippingModeIdChange)}
                                options={[{ id: null, name: 'Reset' }, ...shippingModeData1]}
                            />
                        </Grid>
                        {(loginUser.location.code === 'US' || selectedLocationIndex == 1) ?
                            (<Grid sm={1.5} style={{ padding: "5px" }}>
                                <SelectField
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    label={<Typography fontSize="0.8vw" fontWeight='bold'>Org</Typography>}
                                    value={originState}
                                    onChange={event => onHandleChange(event, onOriginStateChange)}
                                    options={[{ id: null, name: 'Reset' }, ...USA_STATES]}
                                />
                            </Grid>) :
                            (<Grid sm={1.5} style={{ padding: "5px" }}>
                                <SelectField
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    label={<Typography fontSize="0.8vw" fontWeight='bold'>{selectedLocationIndex == 2 ? 'Org' : 'Org'}</Typography>}
                                    value={countryOfOriginId}
                                    onChange={event => onHandleChange(event, onCountryOfOriginIdChange)}
                                    options={[{ id: null, name: 'Reset' }, ...countryOfOriginData1]}
                                />
                            </Grid>)}

                        <Grid sm={2.1} style={{ padding: "5px" }}>
                            <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>Shipper</Typography>}
                                value={shipperId}
                                onChange={event => onHandleChange(event, onShipperIdChange)}
                                options={[{ id: null, name: 'Reset' }, ...shipperNameOptions1]}
                            />
                        </Grid>
                        <Grid sm={2.1} style={{ padding: "5px" }}>
                            <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>Consignee</Typography>}
                                value={consigneeId}
                                onChange={event => onHandleChange(event, onConsigneeIdChange)}
                                options={[{ id: null, name: 'Reset' }, ...consigneeNameOptions1]}
                            />
                        </Grid>
                        {(loginUser.authority === "Admin" || loginUser.department == 1 || loginUser.department == 3) &&<Grid sm={2.1} style={{ padding: "5px" }}>
                            <SelectField
                                sm={12}
                                md={12}
                                lg={12}
                                label={<Typography fontSize="0.8vw" fontWeight='bold'>HAWB</Typography>}
                                value={fileUploadStatus}
                                onChange={event => onHandleChange(event, OnFileUploadStatusChange)}
                                options={loginUser.authority === "Admin" ? adminFileUploadStatuses : (loginUser.department == 1 ? fuFileUploadStatuses : custFileUploadStatuses)}
                            />
                        </Grid>}
                        <Grid sm={2} style={{ padding: "5px" }}>
                            <DateTimePicker
                                sm={12}
                                md={12}
                                lg={12}
                                label='Reminder'
                                boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>Reminder</Typography>}
                                value={ilReminderDate}
                                isShowTime={false}
                                format="dd/MM/yyyy"
                                onChange={(date) => {
                                    if (date) {
                                        var dt = date?.getTime();
                                        dt += 24000 * 3600;
                                        dt -= 1000;
                                        var dat = new Date(dt);
                                        dispatch(onIlReminderDateChange(dat?.toISOString()))
                                    }
                                }}
                            />
                        </Grid>
                        <Grid sm={1.5} style={{ padding: "5px" }}>
                            <DateTimePicker
                                sm={12}
                                md={12}
                                lg={12}
                                label='ETD'
                                boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>ETD</Typography>}
                                value={etdDate}
                                isShowTime={false}
                                format="dd/MM/yy"
                                onChange={date => dispatch(onETDChange(date?.toISOString()))}
                            />
                        </Grid>
                        <Grid sm={1.5} style={{ padding: "5px" }}>
                            <DateTimePicker
                                sm={12}
                                md={12}
                                lg={12}
                                label='ETA'
                                boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>ETA</Typography>}
                                value={etaDate}
                                isShowTime={false}
                                format="dd/MM/yy"
                                onChange={date => dispatch(onETAChange(date?.toISOString()))}
                            />
                        </Grid>
                        <Grid item container flexWrap="nowrap" sm={1} md={1} lg={1} style={{ padding: "5px" }}>
                            <Tooltip title='Reset Search'>

                                <Button color='primary' variant='contained' className="icon-btn MuiButtonBase-root-1" sx={{ background: "#fff", borderRadius: "12px", width: "30px", minWidth: "auto", padding: "0", fontSize: "20px", fontWeight: "700" }}>
                                    <SearchOffIcon fontSize='medium' onClick={() => dispatch(resetOrderTableFilterSlice(null))} />
                                </Button>
                            </Tooltip>
                            <Tooltip title='Reresh Page'>
                                <Button color='primary' variant='contained' className="icon-btn MuiButtonBase-root-1" sx={{ background: "#fff", borderRadius: "12px", width: "30px", minWidth: "auto", padding: "0", fontSize: "20px", fontWeight: "700" }}>
                                    <RefreshIcon fontSize='medium' onClick={() => {
                                        refreshData();
                                    }} />
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </StyledTableCell>

            </TableRow>

            <TableRow className="header">
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0 }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: "0 11px" }}>#</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.date) {
                                sort = clearSort();
                                sort.date = 1;
                            } else {
                                if (sort.date == 1) {
                                    sort = clearSort();
                                    sort.date = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                {(selectedLocationIndex == 0 || selectedLocationIndex == 1) && <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "5vw", minWidth: "5vw", maxWidth: "5vw" }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Order</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.nlno) {
                                sort = clearSort();
                                sort.nlno = 1;
                            } else {
                                if (sort.nlno == 1) {
                                    sort = clearSort();
                                    sort.nlno = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>}

                {((selectedLocationIndex == 0 || selectedLocationIndex == 1) && loginUser.authority != "Admin" && loginUser.department == null || loginUser.department == 1) && <StyledTableCell sx={{ maxWidth: "6vw", minWidth: "6vw", width: "6vw", p: 0, lineHeight: '1' }}>
                    <Grid item container flexWrap="nowrap">
                        {(loginUser.location.code === "IL") && <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>
                            F/U
                        </p>}
                        {(loginUser.location.code != "IL") && <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>
                            {(loginUser.location.code === 'US') ? "US" : "NL"}
                        </p>}
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.fu) {
                                sort = clearSort();
                                sort.fu = 1;
                            } else {
                                if (sort.fu == 1) {
                                    sort = clearSort();
                                    sort.fu = 2;
                                } else
                                    sort = clearSort();
                            }
                            /*if (loginUser.location.code === "IL") {
                                if (!sort.fu) {
                                    sort.fu = 1;
                                } else {
                                    if (sort.fu == 1)
                                        sort.fu = 2;
                                    else
                                        sort.fu = null;
                                }
                            } else if (loginUser.location.code === 'US') {
                                if (!sort.fu) {
                                    sort.fu = 1;
                                } else {
                                    if (sort.fu == 1)
                                        sort.fu = 2;
                                    else
                                        sort.fu = null;
                                }
                            } else {
                                if (!sort.fu) {
                                    sort.fu = 1;
                                } else {
                                    if (sort.fu == 1)
                                        sort.fu = 2;
                                    else
                                        sort.fu = null;
                                }
                            }*/
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>

                </StyledTableCell>}
                {(loginUser.department == 2 || loginUser.department == 3) && loginUser.authority != "Admin" && <StyledTableCell sx={{ minWidth: "6vw", maxWidth: "6vw", width: "6vw", p: 0, lineHeight: '1' }}>
                    <Grid item container flexWrap="nowrap">
                        {((loginUser.department == 2)) && <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>OPS</p>}
                        {((loginUser.department == 3)) && <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Customs</p>}
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if ((loginUser.department == 2)) {
                                if (!sort.ops) {
                                    sort = clearSort();
                                    sort.ops = 1;
                                } else {
                                    if (sort.ops == 1) {
                                        sort = clearSort();
                                        sort.ops = 2;
                                    } else {
                                        sort = clearSort();
                                    }
                                }
                            } else {
                                if (!sort.customs) {
                                    sort = clearSort();
                                    sort.customs = 1;
                                } else {
                                    if (sort.customs == 1) {
                                        sort = clearSort();
                                        sort.customs = 2;
                                    } else {
                                        sort = clearSort();
                                    }
                                }
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>}
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "5vw", minWidth: "5vw", maxWidth: "5vw" }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Type</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.type) {
                                sort = clearSort();
                                sort.type = 1;
                            } else {
                                if (sort.type == 1) {
                                    sort = clearSort();
                                    sort.type = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: `${selectedLocationIndex == 1 ? "7vw" : "4vw"}`, minWidth: `${selectedLocationIndex == 1 ? "7vw" : "4vw"}`, maxWidth: `${selectedLocationIndex == 1 ? "7vw" : "4vw"}` }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Org</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.orgUS) {
                                sort = clearSort();
                                sort.orgUS = 1;
                            } else {
                                if (sort.orgUS == 1) {
                                    sort = clearSort();
                                    sort.orgUS = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>

                {selectedLocationIndex == 2 && <StyledTableCell sx={{ maxWidth: "5vw", minWidth: "5vw", width: "5vw", p: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: '1' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Broker</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.brooker) {
                                sort = clearSort();
                                sort.brooker = 1;
                            } else {
                                if (sort.brooker == 1) {
                                    sort = clearSort();
                                    sort.brooker = 2;
                                } else 
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>}
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: '7vw', maxWidth: '7vw', minWidth: '7vw' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Shipper</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.shipper) {
                                sort = clearSort();
                                sort.shipper = 1;
                            } else {
                                if (sort.shipper == 1) {
                                    sort = clearSort();
                                    sort.shipper = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: '7vw', maxWidth: '7vw', minWidth: '7vw' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Consignee</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.consignee) {
                                sort = clearSort();
                                sort.consignee = 1;
                            } else {
                                if (sort.consignee == 1) {
                                    sort = clearSort();
                                    sort.consignee = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>ETD</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.etd) {
                                sort = clearSort();
                                sort.etd = 1;
                            } else {
                                if (sort.etd == 1) {
                                    sort = clearSort();
                                    sort.etd = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>ETA</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.eta) {
                                sort = clearSort();
                                sort.eta = 1;
                            } else {
                                if (sort.eta == 1) {
                                    sort = clearSort();
                                    sort.eta = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: '6vw' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>POL</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.pol) {
                                sort = clearSort();
                                sort.pol = 1;
                            } else {
                                if (sort.pol == 1) {
                                    sort = clearSort();
                                    sort.pol = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: '6vw' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>POD</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.pod) {
                                sort = clearSort();
                                sort.pod = 1;
                            } else {
                                if (sort.pod == 1) {
                                    sort = clearSort();
                                    sort.pod = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: '6vw' }}>
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>{isFU() ? "PO" : "File #" }</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.po) {
                                sort = clearSort();
                                sort.po = 1;
                            } else {
                                if (sort.po == 1) {
                                    sort = clearSort();
                                    sort.po = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                    <Grid item container flexWrap="nowrap">
                        <p style={{ fontSize: "12px", color: "#2A4464", textAlign: "left", fontWeight: "700", margin: 0, padding: 0 }}>Reminder</p>
                        <span class="sort" onClick={() => {
                            var sort = JSON.parse(JSON.stringify(sortFilter));
                            if (!sort.reminder) {
                                sort = clearSort();
                                sort.reminder = 1;
                            } else {
                                if (sort.reminder == 1) {
                                    sort = clearSort();
                                    sort.reminder = 2;
                                } else
                                    sort = clearSort();
                            }
                            dispatch(onSortFilterChange(sort));
                            //refreshForSort(sort);
                        }}>↕</span>
                    </Grid>
                </StyledTableCell>
                <StyledTableCell sx={{ fontSize: "13px", padding: "11px", pl: 0, pr: 0, width: "800vw" }} align='center' colSpan="20">

                </StyledTableCell>

            </TableRow>
        </TableHead>
    );
};

export default OrderTableHeader;
